import { Link } from "react-router-dom";

export default function Footer() {
  const scrollTo = (href) => {
    if (href.startsWith("/")) return; // handled by Link
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const columns = [
    {
      title: "PRODUCT",
      links: [
        { label: "Features", href: "#features" },
        { label: "Dashboard", href: "#dashboard" },
        { label: "Action plan", href: "#action-plan" },
        { label: "Pricing", href: "#pricing" },
      ],
    },
    {
      title: "COMPANY",
      links: [
        { label: "About", href: "#" },
        { label: "Blog", href: "/blog", isRoute: true },
        { label: "Contact", href: "https://tidycal.com/nick-christensen/30-minute-meeting", external: true },
      ],
    },
    {
      title: "LEGAL",
      links: [
        { label: "Privacy", href: "#" },
        { label: "Terms", href: "#" },
        { label: "Security", href: "#" },
      ],
    },
  ];

  return (
    <footer className="border-t border-[#1A2235] bg-[#030305]" data-testid="footer">
      {/* Big text */}
      <div className="overflow-hidden py-12 border-b border-[#1A2235]">
        <div className="font-heading font-black text-[60px] sm:text-[100px] lg:text-[140px] text-[#0A0D14] leading-none tracking-tighter whitespace-nowrap text-center select-none">
          ICPINTEL
        </div>
      </div>

      {/* Links */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-1 mb-4">
              <span className="font-heading text-sm font-bold tracking-tighter text-white">
                ICP
              </span>
              <span className="font-heading text-sm font-bold tracking-tighter text-[#00F0FF]">
                INTEL
              </span>
              <span className="w-1 h-1 bg-[#00F0FF] rounded-full ml-0.5" />
            </div>
            <p className="font-body text-xs text-[#8B9BB4] leading-relaxed">
              Find your rich customer avatar and get a clear 90-day plan to reach more people like them.
            </p>
          </div>

          {/* Link columns */}
          {columns.map((col) => (
            <div key={col.title}>
              <div className="font-mono-label text-[10px] text-[#005F73] mb-4">
                {col.title}
              </div>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.external ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-body text-sm text-[#8B9BB4] hover:text-[#00F0FF] transition-colors"
                      >
                        {link.label}
                      </a>
                    ) : link.isRoute ? (
                      <Link
                        to={link.href}
                        className="font-body text-sm text-[#8B9BB4] hover:text-[#00F0FF] transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <button
                        onClick={() => scrollTo(link.href)}
                        className="font-body text-sm text-[#8B9BB4] hover:text-[#00F0FF] transition-colors"
                      >
                        {link.label}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-6 border-t border-[#1A2235] flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="font-mono-label text-[10px] text-[#005F73]">
            {new Date().getFullYear()} ICPINTEL. ALL RIGHTS RESERVED.
          </span>
          <div className="flex items-center gap-2">
            <div className="w-1.5 h-1.5 bg-[#00FF66] rounded-full shadow-[0_0_6px_rgba(0,255,102,0.5)]" />
            <span className="font-mono-label text-[10px] text-[#8B9BB4]">
              PRIVATE BETA
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
